import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { EmailSettings } from '../../types/EmailSettings';
import {
    requestAssignEmailSettings,
    requestDisconnectEmailSettings,
    requestTestEmailSettings,
    requestUserEmailSettings,
} from '../userEmailSettings/userEmailSettings';

export function useUserEmailSettings() {
    return useQuery({
        queryKey: [`userEmailSettings`],
        queryFn: async ({ signal }): Promise<EmailSettings> => {
            const result = await requestUserEmailSettings(signal);
            return result;
        },
    });
}

export function useAssignEmailSettings() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data: EmailSettings) => await requestAssignEmailSettings(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['userEmailSettings'] });
        },
    });
}

export function useTestEmailSettings() {
    return useMutation({
        mutationFn: async (data: EmailSettings) => await requestTestEmailSettings(data),
    });
}

// Added data string to have a first argument when call onSuccess on the second argument for mutation function
export function useDisconnectEmailSettings() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data: string) => await requestDisconnectEmailSettings(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['userEmailSettings'] });
        },
    });
}
